module.exports = __webpack_public_path__ + "static/top-7f23661de6deb3ccdc5499c2f89d041f.jpg";